module.exports = (__webpack_require__(0))(164);


//////////////////
// WEBPACK FOOTER
// delegated ./src/views/widgets/ItemListWidget.js from dll-reference girder_lib
// module id = 150
// module chunks = 0